import $ from 'jquery';
import React from 'react';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import ReactDOM from 'react-dom';
import * as API from './api';
import { error } from 'plugins/toastr';
import AcceptContractModal from './components/AcceptContractModal';
import reducers from './reducers';
import { withCurrentReferer } from 'plugins/contextual-back';

export function displayAcceptContractModal(callback) {
  const createLogger = require('redux-logger');
  const logger = createLogger({
    collapsed: true,
  });

  const middleware = [thunk, logger];
  const enhancers = [];

  const store = createStore(
    reducers,
    compose(applyMiddleware(...middleware), ...enhancers)
  );
  const root = document.getElementById('bt-accept-contract');
  const modalRoot = document.getElementById('modal-root');
  const id = root.getAttribute('data-id');
  const customerId = root.getAttribute('data-customer');
  $(root).removeAttr('href');

  const modal = ReactDOM.render(
    <Provider store={store}>
      <AcceptContractModal
        id={parseInt(id, 10)}
        customerId={parseInt(customerId, 10)}
        refresh={true}
      />
    </Provider>,
    modalRoot
  );

  displayModal(modal, callback);

  const confirmButton = document.getElementById('bt-confirm-contract');
  if (confirmButton) {
    confirmButton.onclick = () => {
      $(confirmButton).addClass('disabled');
      $(confirmButton).addClass('loading');
      API.update(id, store.getState().form).then(
        res => window.location.replace(withCurrentReferer(res.url)),
        err => handleError(err, store)
      );
    };
  }
}

function dispatchErrors(store, error) {
  const errors = Object.keys(error)
    .map(key => {
      return key.substring(4);
    })
    .filter(e => e !== null);

  store.dispatch({
    type: 'errors',
    payload: errors,
  });
}

function handleError(err, store) {
  const confirmButton = document.getElementById('bt-confirm-contract');
  console.log('Error attempting to save case', err);
  $(confirmButton).removeClass('disabled');
  $(confirmButton).removeClass('loading');
  if (err.res.status === 400) {
    // Handling errors properly
    err.res.json().then(json => dispatchErrors(store, json));
  } else if (err.res.status === 409) {
    err.res.text().then(message => error(message));
  } else {
    error("Une erreur est survenue pendant l'acceptation du contrat");
  }
}

function displayModal(modal, callback) {
  // Appending content to body
  $(document.body).append(modal);

  // Handling approve button
  const $modal = $('#modal-root');

  $modal
    .modal({
      onApprove: element => {},
    })
    .modal('show');
}



// WEBPACK FOOTER //
// ./src/modules/saas/aast/case-contract/validation/accept-contract.js